import { render, staticRenderFns } from "./BookDetails.vue?vue&type=template&id=548270e1&scoped=true"
import script from "./BookDetails.vue?vue&type=script&lang=js"
export * from "./BookDetails.vue?vue&type=script&lang=js"
import style0 from "./BookDetails.vue?vue&type=style&index=0&id=548270e1&prod&lang=scss&scoped=true"
import style1 from "./BookDetails.vue?vue&type=style&index=1&id=548270e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548270e1",
  null
  
)

export default component.exports